import axios from 'axios';
import Resumen from '@/models/Resumen';
import Fiscal from '@/models/Fiscal';
import TipoComprobante from '@/models/TipoComprobante';
function defaultState() {
	return {
		resumen: [],
		tipocomprobantes: [],
		tableData: [],
	};
}
const state = defaultState();
const getters = {};
const mutations = {
	setResumen(state: { resumen: Resumen[] }, resumen: Resumen[]) {
		state.resumen = resumen;
	},
	setTipoDeComprobantes(state: { tipocomprobantes: TipoComprobante[] }, tcomprobantes: TipoComprobante[]) {
		state.tipocomprobantes = tcomprobantes;
	},
	setTableData(state: { tableData: Fiscal[] }, data: Fiscal[] | Fiscal) {
		!Array.isArray(data) ? state.tableData.push(data) : (state.tableData = []);
	},
};
const actions = {
	async callResumenFiscales({ commit }, params: { data: object; start: number; limit: number }): Promise<Fiscal[] | void> {
		try {
			const url = `./api/public/proxy/cgi/etenet_cabcbte?start=${params.start}&limit=${params.limit}`;
			const response = await axios.get(url, params.data);

			const items = response && response.data && Array.isArray(response.data.items) ? response.data.items : [];

			items.sort((a, b) => {
				const ax = a && a.id ? parseInt(a.id, 10) : 0;
				const bx = b && b.id ? parseInt(b.id, 10) : 0;
				return bx - ax;
			});

			for (let i = 0; i < items.length; i++) commit('setTableData', items[i]);

			const resumenes = response.data && Array.isArray(response.data.resumenes) ? response.data.resumenes : [];
			commit('setResumen', resumenes);

			const tipos = response.data && Array.isArray(response.data.tipodecomprobantes) ? response.data.tipodecomprobantes : [];
			commit('setTipoDeComprobantes', tipos);

			return items;
		} catch (error) {
			console.log(error);
		}
	},
	// async callResumenFiscales({ commit, dispatch }, params: { data: object; start: number; limit: number }): Promise<void> {
	// 	try {
	// 		const response = await axios.get(`./api/public/proxy/cgi/etenet_cabcbte?start=${params.start}&limit=${params.limit}`, params.data);
	// 		response.data.items.sort((a, b) => parseInt(b.id) - parseInt(a.id));
	// 		if (response.data.items) {
	// 			response.data.items.forEach((element: Fiscal) => {
	// 				//TODO: codigo necesario cuando se pase formato a tablas.
	// 				//var dateParts = element.fecha.split('-');
	// 				//element.fecha = dateParts[2] + '/' + dateParts[1] + '/' + dateParts[0];
	// 				commit('setTableData', element);
	// 			});
	// 		}
	// 		commit('setResumenes', response.data.resumenes as Resumen);
	// 		commit(
	// 			'setTipoDeComprobantes',
	// 			(response.data.tipodecomprobantes as TipoComprobante) ? (response.data.tipodecomprobantes as TipoComprobante) : []
	// 		);

	// 		return response.data.items;
	// 	} catch (error) {
	// 		console.log(error);
	// 	}
	// },
	resetItemsFiscales({ commit }): void {
		let empty: Object[] = [];
		commit('setTableData', empty);
	},
	async downloadFileFiscales(
		{ commit, dispatch },
		params: { recordSelected: { codcom1: string; codtal1: string; numero1: string } }
	): Promise<void> {
		var recordSelected = params.recordSelected;
		const response = await axios.get(
			`./api/public/proxy/imprime?codcom=${recordSelected.codcom1}&codtal=${recordSelected.codtal1}&numero=${recordSelected.numero1}`
		);
		return response.data;
	},
	reset(): void {
		Object.assign(state, defaultState());
	},
};
export default {
	state,
	getters,
	actions,
	mutations,
};
